<script>
import VueSelect from "vue-select";
import SelectIdentity from "$vueCommon/components/Select/SelectIdentity.vue";
import CheckoutAPI from "$vueCommon/classes/API/CheckoutAPI.js";

export default {
    components: {
        SelectIdentity,
        VueSelect
    },
    props: {
        domain: Object,
        identities: Array,
        selectedIdentityId: Number,
        onDismiss: Function,
        onConfirm: Function
    },
    mounted() {
        this.setSelectedIdentity();
    },
    data() {
        return {
            selectedIdentity: null,
            localSelectedIdentity: null,
            testy: null,
            sameContactsDomain: true,
            savingDomainRegistrantUserIdentity: false
        }
    },
    computed: {
        identitiesList() {
            if (!Array.isArray(this.identities)) {
                return [];
            }

            return this.identities.map(identity => {
                identity.is_business = (!!identity.company_name && identity.company_name.trim().length > 0) || (!!identity.tax_id && identity.trim().length > 0);

                const parts = [];

                if (!identity.is_business) {
                    parts.push(identity.first_name + ' ' + identity.last_name);
                } else {
                    parts.push(identity.company_name);
                }

                const address = [];
                if (identity.address) {
                    address.push(identity.address);
                }

                if (identity.address2) {
                    address.push(identity.address2);
                }

                if (address.length) {
                    parts.push(address.join(' '));
                }

                if (identity.city) {
                    parts.push((identity.postal_code ? identity.postal_code + ' ' : '') + identity.city);
                }

                identity.label = parts.join(', ');

                return identity;
            });
        },
        requiredRegistrantFields() {
            const req = this.domain && this.domain.requirements ? this.domain.requirements : [];
            const out = [];

            const has = (name) => {
                if (Array.isArray(req)) {
                    return req.includes(name);
                }

                if (typeof req === 'object') {
                    return !!req[name];
                }

                return false;
            };

            ['id_number', 'dob', 'pob'].forEach(field => {
                if (has(field)) {
                    out.push(field);
                }
            });

            return out;
        }
    },
    methods: {
        setSelectedIdentity() {
            for (const identity of this.identities) {
                if (identity.id === this.selectedIdentityId) {
                    this.localSelectedIdentity = identity;
                }
            }
        },
        onIdentitySelected(identity) {
            this.localSelectedIdentity = identity;
        },
        saveDomainIdentity() {
            this.savingDomainRegistrantUserIdentity = true;
            CheckoutAPI.postDomainRegistrantUserIdentity(this.domain.rowId, this.localSelectedIdentity).then(response => {
                this.savingDomainRegistrantUserIdentity = false;
                this.onConfirm({identity: this.localSelectedIdentity, sameDomain: this.sameContactsDomain});
            });
        }
    }
}
</script>
<template>
    <h4>{{ $translate('checkout.registrant_data') }}</h4>
    <SelectIdentity
        :identities="identities"
        :selected="localSelectedIdentity"
        :buttonAddText="$translate('checkout.add_new_address')"
        identityType="registrant"
        :saving="savingDomainRegistrantUserIdentity"
        :requiredFields="requiredRegistrantFields"
        @onSelected="onIdentitySelected"
    />
    <div class="pretty p-default p-primary mt-4">
        <input type="checkbox" v-model="sameContactsDomain" id="sameContactsDomain" name="sameContactsDomain">
        <div class="state p-primary">
            <label for="sameContactsDomain">{{ $translate('checkout.use_same_registrant_details_for_other_domains') }}</label>
        </div>
    </div>
    <div class="row mt-4">
        <div class="col-6">
            <button class="btn btn-circle w-100" @click="onDismiss()">{{ $translate('checkout.cancel') }}</button>
        </div>
        <div class="col-6">
            <button class="btn btn-primary w-100"
                    @click="saveDomainIdentity"
                    :class="{disabled: savingDomainRegistrantUserIdentity}">
                <template v-if="!savingDomainRegistrantUserIdentity">{{ $translate('checkout.apply') }}</template>
                <template v-if="savingDomainRegistrantUserIdentity">
                    <span class="vue-loader"></span>
                </template>
            </button>
        </div>
    </div>
</template>
